/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CampaignOverview/view.blocks to change it.
import Breakdown from './Breakdown/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CampaignOverview({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Pie/CampaignOverview"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="CampaignOverview.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Breakdown
  viewPath={`${viewPath}/Breakdown`}
/>
</div>
{children}
</React.Fragment>)
}